<template>
  <SCADropdown
    v-model:is-open="open"
    placement="right-start"
    :offset-y="6.75"
    trigger="click"
    @positioned="builder?.focus()"
    @closed="emit('closed')"
  >
    <template #trigger="{ target }">
      <SCAIconButton
        :popovertarget="target"
        :class="$style.trigger"
        :disabled="disabled"
        size="small"
        appearance="secondary"
        icon="phosphor/caret-right"
        :aria-label="$t('columnFilter.list.openConditions')"
        :title="$t('columnFilter.list.openConditions')"
        test-id="column-filter-list-conditions"
      />
    </template>
    <template #default>
      <div :class="$style.panel" test-id="column-filter-list-conditions-panel">
        <SCAConditionBuilder
          ref="builder"
          kind="text"
          :operator-options="operatorOptions"
          :default-operator="LIST_CONDITION_DEFAULT_OPERATOR"
          :rows="rows"
          @change="(changed) => emit('change', changed)"
          @submit="submit"
        />
      </div>
    </template>
  </SCADropdown>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import SCADropdown from "../../Dropdown/SCADropdown.vue";
import SCAIconButton from "../../SCAIconButton.vue";
import type { ConditionRow } from "../condition/conditionChain";
import { LIST_CONDITION_DEFAULT_OPERATOR, operatorOptionsFor } from "../condition/operators";
import SCAConditionBuilder from "../condition/SCAConditionBuilder.vue";
import type { FilterOperator } from "../filterModel";

const props = defineProps<{
  disabled?: boolean;
  /** Listed in the operator menu but not selectable. */
  disabledOperators: readonly FilterOperator[];
  /** The complete rows of the current filter. */
  rows: readonly ConditionRow[];
}>();

const emit = defineEmits<{
  change: [rows: ConditionRow[]];
  closed: [];
  submit: [];
}>();

const open = ref(false);
const builder = ref<InstanceType<typeof SCAConditionBuilder> | null>(null);

function submit() {
  open.value = false;
  emit("submit");
}

const operatorOptions = computed(() => operatorOptionsFor("text", [], props.disabledOperators));
</script>

<style module lang="scss">
.trigger:not(:disabled),
.trigger:not(:disabled) * {
  cursor: pointer;
}

.panel {
  width: 200px;
}
</style>
